import React, { useEffect, useState } from "react";
import Image from "next/future/image";

import { useRouter } from "next/router";
import { useForm } from "react-hook-form";
import { FormattedMessage, useIntl } from "react-intl";
import { Col, Container, Row } from "react-bootstrap";
import Swal from "sweetalert2";

import callIcon from "../../assets/images/svg/call.svg";
import server from "../../api/server";
import SectionHead from "../Shared/SectionHead";
import FileUpload from "../Shared/FileUpload";

const Hiring = ({ formSubtitle, formTitle }) => {
  const { formatMessage } = useIntl();

  const [file, setFile] = useState({});
  const fileChange = async (e) => {
    const file = e.target.files?.[0];

    if (file) {
      const formData = new FormData();
      formData.append("file", file);
      const { data } = await server.post("/upload", formData);

      setFile({
        preview: URL.createObjectURL(file),
        path: data.data.file.path,
      });

      // عشان ترسل المسار مع البيانات النهائية
      setValue("cv", data.data.file.path, { shouldValidate: true });
    }
  };
  const { locale } = useRouter();
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    try {
      data.cv = file?.path || "";
      await server.post("/requests", data);
      reset();
      setFile({});
      Swal.fire(
        `${formatMessage({
          id: "thanks",
        })}`,
        `${formatMessage({
          id: "thankMsg",
        })}`,
        "success"
      );
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <div className="hiring-form">
        <Container>
          <Row>
            {(formTitle || formSubtitle) && (
              <Col xl={3} lg={3} md={12} xs={12}>
                <SectionHead subtitle={formSubtitle} title={formTitle} />
              </Col>
            )}
            <Col lg={formSubtitle || formTitle ? 8 : 12} md={12} xs={12}>
              <form onSubmit={handleSubmit(onSubmit)}>
                <Row className="flex-wrap">
                  <Col xs={12}>
                    <div
                      className="form-group"
                      data-aos="fade-up"
                      data-aos-duration="300"
                      data-aos-delay="100"
                    >
                      <input
                        className="form-control"
                        {...register("name", {
                          required: true,
                        })}
                        placeholder={formatMessage({
                          id: "fullName",
                        })}
                      />
                      {errors?.name?.type === "required" && (
                        <p className="error">
                          <FormattedMessage id="required" />
                        </p>
                      )}
                    </div>
                  </Col>

                  <Col md={6} sm={6} xs={12}>
                    <div
                      className="form-group"
                      data-aos="fade-up"
                      data-aos-duration="300"
                      data-aos-delay="200"
                    >
                      <input
                        className="form-control"
                        {...register("email", {
                          required: {
                            value: true,
                            message: "required",
                          },
                          pattern: {
                            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                            message: "invalidEmail",
                          },
                        })}
                        placeholder={formatMessage({
                          id: "email",
                        })}
                      />
                      {errors?.email?.message && (
                        <p className="error">
                          <FormattedMessage id={errors.email.message} />
                        </p>
                      )}
                    </div>
                  </Col>

                  <Col md={6} sm={6} xs={12}>
                    <div
                      className="form-group"
                      data-aos="fade-up"
                      data-aos-duration="300"
                      data-aos-delay="300"
                    >
                      <input
                        className="form-control"
                        {...register("phone", {
                          required: {
                            value: true,
                            message: "required",
                          },
                          pattern: {
                            value: /^[0-9]{9,15}$/,
                            message: "invalidPhone",
                          },
                        })}
                        placeholder={formatMessage({ id: "phone" })}
                      />
                      {errors?.phone?.message && (
                        <p className="error">
                          <FormattedMessage id={errors.phone.message} />
                        </p>
                      )}
                    </div>
                  </Col>

                  {/* Gender */}
                  <Col xs={12}>
                    <div
                      className="form-group radio-group"
                      data-aos="fade-up"
                      data-aos-duration="300"
                      data-aos-delay="350"
                    >
                      <label className="form-label d-block">
                        <FormattedMessage id="gender" />:
                      </label>
                      <div className="d-flex gap-3">
                        <label>
                          <input
                            type="radio"
                            value="male"
                            id="male"
                            {...register("gender", { required: true })}
                          />
                          <label htmlFor="male">
                            <FormattedMessage id="male" />
                          </label>
                        </label>
                        <label>
                          <input
                            type="radio"
                            value="female"
                            id="female"
                            {...register("gender", { required: true })}
                          />
                          <label htmlFor="female">
                            <FormattedMessage id="female" />
                          </label>
                        </label>
                      </div>
                      {errors?.gender && (
                        <p className="error">
                          <FormattedMessage id="required" />
                        </p>
                      )}
                    </div>
                  </Col>

                  {/* Age */}
                  <Col xs={12}>
                    <div
                      className="form-group radio-group"
                      data-aos="fade-up"
                      data-aos-duration="300"
                      data-aos-delay="400"
                    >
                      <label className="form-label d-block">
                        <FormattedMessage
                          id="age"
                          defaultMessage="الفئة العمرية"
                        />
                        :
                      </label>
                      <div className="d-flex flex-wrap gap-3">
                        {["20-25", "26-35", "36-45", "50+"].map(
                          (range, index) => {
                            const id = `age-${index}`;
                            return (
                              <div key={range}>
                                <input
                                  type="radio"
                                  value={range}
                                  id={id}
                                  {...register("ageRange", { required: true })}
                                />
                                <label htmlFor={id}>{range}</label>
                              </div>
                            );
                          }
                        )}
                      </div>
                      {errors?.ageRange && (
                        <p className="error-hint">
                          <FormattedMessage
                            id="required"
                            defaultMessage="هذا الحقل مطلوب"
                          />
                        </p>
                      )}
                    </div>
                  </Col>

                  {/* Job */}
                  <Col xs={12}>
                    <div
                      className="form-group radio-group"
                      data-aos="fade-up"
                      data-aos-duration="300"
                      data-aos-delay="350"
                    >
                      <label className="form-label d-block">
                        <FormattedMessage id="job" defaultMessage="الوظيفة" />:
                      </label>
                      <div className="d-flex flex-wrap gap-3">
                        {["lawyer", "trainer", "admin", "consultant"].map(
                          (roleKey, index) => {
                            const id = `job-${index}`;
                            return (
                              <div key={roleKey}>
                                <input
                                  type="radio"
                                  value={roleKey}
                                  id={id}
                                  {...register("jobRole", { required: true })}
                                />
                                <label htmlFor={id}>
                                  <FormattedMessage id={roleKey} />
                                </label>
                              </div>
                            );
                          }
                        )}
                      </div>
                      {errors?.jobRole && (
                        <p className="error">
                          <FormattedMessage
                            id="required"
                            defaultMessage="هذا الحقل مطلوب"
                          />
                        </p>
                      )}
                    </div>
                  </Col>

                  {/* Qualification */}
                  <Col xs={12}>
                    <div
                      className="form-group radio-group"
                      data-aos="fade-up"
                      data-aos-duration="300"
                      data-aos-delay="450"
                    >
                      <label className="form-label d-block">
                        <FormattedMessage
                          id="qualification"
                          defaultMessage="المؤهل الدراسي"
                        />
                        :
                      </label>
                      <div className="d-flex flex-wrap gap-3">
                        {[
                          "diploma",
                          "highschool",
                          "bachelor",
                          "master",
                          "phd",
                        ].map((level) => (
                          <div key={level}>
                            <input
                              type="radio"
                              value={level}
                              id={`qualification-${level}`}
                              {...register("qualification", {
                                required: true,
                              })}
                            />
                            <label htmlFor={`qualification-${level}`}>
                              <FormattedMessage id={level} />
                            </label>
                          </div>
                        ))}
                      </div>
                      {errors?.qualification && (
                        <p className="error-hint">
                          <FormattedMessage
                            id="required"
                            defaultMessage="هذا الحقل مطلوب"
                          />
                        </p>
                      )}
                    </div>
                  </Col>

                  {/* Experience */}
                  <Col xs={12}>
                    <div
                      className="form-group "
                      data-aos="fade-up"
                      data-aos-duration="300"
                      data-aos-delay="400"
                    >
                      <label
                        className="form-label d-block"
                        htmlFor="experience"
                      >
                        <FormattedMessage id="experience" />:
                      </label>
                      <textarea
                        className="form-control py-2"
                        id="experience"
                        style={{
                          height: "120px",
                        }}
                        {...register("experience", {
                          required: true,
                        })}
                        placeholder={formatMessage({
                          id: "experience",
                        })}
                      />
                      {errors?.experience?.type === "required" && (
                        <p className="error">
                          <FormattedMessage id="required" />
                        </p>
                      )}
                    </div>
                  </Col>

                  <Col md={6} sm={6} xs={12}>
                    <div
                      className="form-group"
                      data-aos="fade-up"
                      data-aos-duration="300"
                      data-aos-delay="400"
                    >
                      <label className="form-label d-block" htmlFor="file">
                        <FormattedMessage id="cv" />:
                      </label>
                      <div className="image-uploader image-contain">
                        <input
                          type="file"
                          className="form-control"
                          accept=".pdf" // فقط ملفات PDF
                          onChange={fileChange}
                        />
                        {/* نستخدم register هنا فقط لتسجيل القيمة بعد الرفع */}
                        <input
                          type="hidden"
                          {...register("cv", { required: true })}
                        />
                      </div>
                      {errors?.cv && (
                        <p className="error">
                          <FormattedMessage id="required" />
                        </p>
                      )}
                    </div>
                  </Col>

                  <Col sm={12} xs={12}>
                    <div
                      className="form-group"
                      data-aos="fade-up"
                      data-aos-duration="300"
                      data-aos-delay="500"
                    >
                      <button type="submit" className="btn  ">
                        <div>
                          <Image
                            src={callIcon.src}
                            width={22}
                            height={22}
                            alt=""
                            loading="lazy"
                          />
                        </div>
                        <FormattedMessage id="send" />
                      </button>
                    </div>
                  </Col>
                </Row>
              </form>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Hiring;
